export const toThousands = (num) => {
  const isMinus = num < 0;
  const splitDecimal = Math.abs(num || 0)
    .toString()
    .split('.');
  let newNum = splitDecimal[0];
  let result = '';
  while (newNum.length > 3) {
    result = `,${newNum.slice(-3)}${result}`;
    newNum = newNum.slice(0, newNum.length - 3);
  }
  if (newNum) {
    result = newNum + result;
  }
  return `${isMinus ? '-' : ''}${result}${
    splitDecimal[1]
      ? `.${splitDecimal[1].length === 1 ? `${splitDecimal[1]}0` : splitDecimal[1]}`
      : '.00'
  }`;
};
